import { utils } from '../../../Foundation';

const originalControllers = (element) => {
    const hiddenFields = [...element.querySelectorAll('.configurator__accessories-item + input[type="hidden"]')];
    const originalContentItems = [...element.querySelectorAll('.configurator__accessories-item')];
    let temp = '';
    for(let [index, item] of originalContentItems.entries()) {
        temp += `
            <div class="hidden_item">
                ${item.outerHTML}
                ${hiddenFields[index].outerHTML}
            </div>
        `;
    }
    return temp;
}

const createHeader = (element) => {
    let heading = element.querySelector('h2') ? element.querySelector('h2') : document.createElement('h2');
    heading.classList.add('configurator_title');
    if (heading.innerText === '') {
        // IF ITE Wireless Accessories
        // Else IF ITE Chargers
        if (element.querySelector('.number-input__field')) {
            heading = document.querySelector('[id*="_AccessoriesContainer"] h2');
        } else if (element.querySelector('.configurator__accessory-checkbox')) {
            heading = document.querySelector('[id*="_ChargerContainer"] h2');
        }
    }
    return heading.outerHTML;
}

const getItemImage = (item) => {
    const imageElement = item.querySelector('.accessoryImage');
    const imageAltText = imageElement.getAttribute('alt') ? imageElement.getAttribute('alt') : '';
    const imageSource = imageElement.getAttribute('src') ? imageElement.getAttribute('src') : '';
    return {imageAltText, imageSource}
}

const getItemTexts = (item) => {
    const title = item.querySelector('.configurator__accessory-title').innerText;
    const sku = item.querySelector('.configurator__accessory-sku').innerText;
    const stock = item.querySelector('.configurator__accessory-stock').innerText;
    return {title, sku, stock}
}

const getItemQuantity = (item) => {
    const quantityWrapper = item.querySelector('.configurator__accessory-quantity') ? item.querySelector('.configurator__accessory-quantity') : null;
    const checkboxWrapper = item.querySelector('div.configurator__accessory-checkbox') ? item.querySelector('div.configurator__accessory-checkbox') : null;
    if (quantityWrapper) {
        quantityWrapper.classList.add('product-item__quantity');
        quantityWrapper.removeAttribute('id');
        const quantityField = quantityWrapper.querySelector('.number-input__field');
        let versionGeneric = document.querySelector('accessories-carousel.version-generic');
        if (versionGeneric) {
            quantityField.setAttribute('data-id', quantityField.name);
        } else {
            quantityField.setAttribute('data-id', quantityField.id);
        }
        quantityField.removeAttribute('name');
        quantityField.removeAttribute('id');
        quantityField.removeAttribute('style');
        return quantityWrapper.outerHTML;
    }
    if (checkboxWrapper) {
        checkboxWrapper.classList.add('product-item__checkbox');
        checkboxWrapper.removeAttribute('id');
        const checkboxField = checkboxWrapper.querySelector('input.configurator__accessory-checkbox');
        checkboxField.setAttribute('data-id', checkboxField.id);
        checkboxField.removeAttribute('name');
        checkboxField.removeAttribute('id');
        checkboxField.removeAttribute('style');
        return checkboxWrapper.outerHTML;
    }
}

const getItemWarranty = (item) => {
    const warrantyElement = item.querySelector('.configurator__accessory-warranty');
    if(!warrantyElement) return '';
    const warrantySelectElement = warrantyElement.querySelector('select');

    let versionGeneric = document.querySelector('accessories-carousel.version-generic');
    if (versionGeneric) {
        warrantySelectElement.setAttribute('data-id', warrantySelectElement.name);
    } else {
        warrantySelectElement.setAttribute('data-id', warrantySelectElement.id);
    }

    warrantyElement.removeAttribute('id');
    warrantyElement.querySelector('input[type="hidden"]')?.remove();
    warrantySelectElement.removeAttribute('name');
    warrantySelectElement.removeAttribute('id');
    return warrantyElement.outerHTML;
}

const createContentItem = (item) => {
    const {imageAltText, imageSource} = getItemImage(item);
    const {title, sku, stock} = getItemTexts(item);
    const quantity = getItemQuantity(item);
    const warranty = getItemWarranty(item);

    let template = `
    <div class="product-deck__item swiper-slide product-list">
        <div class="configurator__accessories-item">
            <div class="configurator__accessory-inner">
                <div class="product-item__image">
                    <img class="accessoryImage" alt="${imageAltText}" src="${imageSource}">
                    ${quantity}
                </div>

                <div class="configurator__accessory-content">
                    <div class="configurator__accessory-info">
                        <div>
                            <span class="configurator__accessory-title">${title}</span>
                        </div>
                    </div>
                    <div class="configurator__accessory-input">
                        <span class="configurator__accessory-sku">${sku}</span>
                        ${stock ? `<a class="configurator__accessory-stock" target="_blank">${stock}</a>` : ''}
                    </div>
                </div>
            </div>
            ${warranty}
        </div>
    </div>
    `;
    return template;
}

const createContentItems = (element) => {
    let template = '';
    const contentItems = [...element.querySelectorAll('.configurator__accessories-item')];
    for(let item of contentItems) {
        template += createContentItem(item);
    };
    return template;
}


const createSectionTemplate = (element) => {
    const controllers = originalControllers(element);
    const header = createHeader(element);
    const contents = createContentItems(element);
    
    return `
    <section class="product_spot configurator__accessories">
        <div class="product-deck swiper-container disabled_swiper" data-product-spot data-loop="false">
            <div class="product-list-header">
                ${header}
                <div class="swiper_navigation">
                    <div class="navigation_container">
                        <div class="button-prev button-container">
                            <div class="swiper-button swiper-button-prev"></div>
                        </div>
                        <div class="button-next button-container">
                            <div class="swiper-button swiper-button-next"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="product-deck__container swiper-wrapper product-list-wrapper">
                ${contents}
            </div>

            <div class="swiper-pagination product-deck__pagination"></div>
            <div class="hidden hiddenController">
                ${controllers}
            </div>
        </div>
    </section>
    `;
}

export { createSectionTemplate }